import gql from 'graphql-tag';
import React, {FunctionComponent, useState} from 'react';
import {useQuery} from '@apollo/client';
import {useLocation} from 'react-router';
import Card from './card/Card';
import CardTitle from './card/CardTitle';
import TitleCaption from './card/TitleCaption';
import TitleNumber from './card/TitleNumber';
import CardPaginator from './card/CardPaginator';
import LastEventsTable from './LastEventsTable';
import CardContent from './card/CardContent';
import {ISchedule} from '../../models/event/Schedule';
import {ILocation} from '../../models/event/Location';
import {getNumberParam} from '../../utils/Parameters';

const PastEvents: FunctionComponent = () => {
  const QUERY_PARAM = 'past';
  const location = useLocation();
  const activePage = getNumberParam(location.search, QUERY_PARAM, 1);

  const count = 3;
  const [skip, setSkip] = useState((activePage - 1) * count);
  const [total, setTotal] = useState(0);

  const handlePageSwitch = (page: number) => {
    const newSkip = (page - 1) * count;
    setSkip(newSkip);
  };

  const calculatePage = () => Math.floor(skip / count) + 1;

  const initialLoading = () => loading && total === 0;

  const {data, loading} = useQuery<EventsFeedData, EventsFeedVars>(query, {
    variables: {
      skip, count
    },
    onCompleted: (feedData) => setTotal(feedData.pastEvents.total)
  });

  return (
    <Card wide={true} loading={initialLoading()}>
      <CardTitle wide={false}>
        <TitleCaption subtitle="in the last 2 weeks">Past events</TitleCaption>
        <TitleNumber value={total}/>
      </CardTitle>
      {data && data.pastEvents.total !== 0 &&
        <CardContent noBorders={false} loading={loading}>
          <LastEventsTable events={data.pastEvents.events}/>
        </CardContent>
      }
      {data && <CardPaginator total={data.pastEvents.total}
                              page={calculatePage()} perPage={data.pastEvents.count}
                              className="px-5"
                              queryParamName={QUERY_PARAM}
                              onNextClick={handlePageSwitch} onPrevClick={handlePageSwitch}/>}
    </Card>
  );
};

export default PastEvents;


interface Statistics {
  students: number;
  evaluations: number;
  certificates: number;
}

export interface PastEvent {
  id: number;
  title: string;
  schedule: ISchedule;
  location: ILocation;
  statistics: Statistics;
}

interface EventsFeed {
  total: number;
  count: number;
  skip: number;
  events: PastEvent[];
}

interface EventsFeedData {
  pastEvents: EventsFeed;
}

interface EventsFeedVars {
  skip: number;
  count: number;
}

const query = gql`
  query PastEvents($skip: Int!, $count: Int!) {
    pastEvents(endedLessThan: "2 weeks", orderBy: start_desc, skip: $skip, count: $count) {
      total
      count
      skip

      events {
        id
        title
        schedule {
          start
          end
          timezone
        }
        location {
          online
          country
          city
        }
        statistics {
          students
          evaluations
          certificates
        }
      }
    }
  }
`;
